import React, {forwardRef, Fragment, useImperativeHandle, useState} from "react";
import {useTranslation} from "react-i18next";
import {Dialog, DialogTitle, Grid, IconButton, Stack, Typography,} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SiteService from "@/services/location/SiteService";
import {useSnackbar} from "notistack";
import {CancelButton, SavingButton} from "@/components/data-grid/CustomButton";
import SnackbarUtil from "@/utils/SnackbarUtil";
import ActionButton from "@/components/actions/ActionButton";
import DeviceService from "@/services/dms/DeviceService";

const dialogStyle = {
  "& .MuiPaper-root": {width: "400px", top: "1vh", overflowX: "hidden", marginBottom: "50px"},
  ".MuiDialog-paper": {maxWidth: "100vw"},
  overflowX: "hidden",
};

export function DeleteAction({setInfo}: any) {
  const {t} = useTranslation();

  return (
    <ActionButton
      title={t("common.delete")}
      icon="icon-ic_delete"
      handleClick={() => {
        setInfo(true);
      }}
    >
    </ActionButton>
  );
}

const SiteDelete = (props: any, ref: any) => {
  const [info, setInfo] = useState<boolean>(false);
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [siteIds, setSiteIds] = useState<any>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  useImperativeHandle(ref, () => ({
    showDelete: async (id: string) => {
      setSiteIds({id})
      setInfo(false)
    }
  }));
  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (siteIds.length == 0 || siteIds.id.length == 0) {
          setInfo(false);
          SnackbarUtil.error(t("location.site.Select Site first"), {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          return;
        }
      };
  const onSubmit = async (event: any) => {
    try {
      setLoading(true)
      // 收集所有站点处理的Promise
      const sitePromises = siteIds.id.map(async (site: any) => {
        try {
          // 检查站点是否为默认站点
          const retrieveRes = await SiteService.retrieve(site);
          if (retrieveRes.data?.data['code'] === 'DEFAULT') {
            enqueueSnackbar(t("location.site.default site delete error"), {
              variant: "error",
              anchorOrigin: {vertical: "top", horizontal: "center"}
            });
            return false; // 标记此站点删除失败
          }

          // 检查站点是否绑定了设备
          const {data} = await DeviceService.list({current: 1, pageSize: 1, siteId: site});
          if (data.total > 0) {
            enqueueSnackbar(t("location.site.alreadyBinding"), {
              variant: "error",
              anchorOrigin: {vertical: "top", horizontal: "center"}
            });
            return false; // 标记此站点删除失败
          }

          // 删除站点
          const destroyRes = await SiteService.destroy(site.toString());
          if (destroyRes.status === 200) {
            SnackbarUtil.success(t('common.success'));
            return true; // 标记此站点删除成功
          } else {
            return false;
          }
        } catch (error) {
          console.error("站点处理错误:", error);
          return false;
        }
      });

      // 等待所有Promise完成
      const results = await Promise.all(sitePromises);

      // 检查是否有至少一个站点删除成功
      const hasSuccess = results.some(result => result);
      if (hasSuccess && props.reloadTable) {
        props.reloadTable(); // 刷新表格
      }
    } catch (e) {
      console.log("error===", e);
    } finally {
      setInfo(false);
      setLoading(false)
    }
  };

  return (
    <Fragment>
      <Grid item={true} onClick={toggleDrawer(true)}>
        <DeleteAction setInfo={setInfo}/>
      </Grid>
      <Dialog
        open={info}
        // onClose={()=>setInfo(false)}
        sx={dialogStyle}
      >
        <DialogTitle style={{marginBottom: "-25px"}}>
          {t("location.site.Delete Site?")}
          <IconButton
            aria-label="close"
            onClick={() => setInfo(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <Typography sx={{p: 3}}>{t("location.site.Delete Confirm")}</Typography>
        <Grid style={{marginLeft: "20px", marginRight: "20px", marginBottom: "20px"}}>
          <Stack spacing={3} direction={"row"}>
            <CancelButton
              onClick={() => {
                setInfo(false);
              }}
            />
            <SavingButton loading={isLoading} onClick={onSubmit} children={t("common.confirm")}/>
          </Stack>
        </Grid>
      </Dialog>
    </Fragment>
  );
};

export default forwardRef(SiteDelete);
